import { registerPainter } from '../zrender.js';
import Painter from './Painter.js';
registerPainter('svg', Painter);
